import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

var Transfer = function Transfer(props) {
  var _props$color = props.color,
      color = _props$color === void 0 ? 'currentColor' : _props$color,
      size = props.size,
      style = props.style;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.6711 16.2593L18.7048 13.2931C18.3148 12.9026 17.6849 12.9026 17.2949 13.2931C16.8999 13.6836 16.8999 14.3166 17.2949 14.707L18.5861 15.9999L14 15.9999C13.45 15.9999 13 16.4474 13 16.9999C13 17.5524 13.45 17.9999 14 17.9999H18.5863L17.2949 19.293C16.8999 19.6835 16.8999 20.3165 17.2949 20.707C17.6849 21.0975 18.3148 21.0975 18.7048 20.707L21.6738 17.7381C21.874 17.5553 22 17.2923 22 16.9999C22 16.7062 21.8728 16.4422 21.6711 16.2593Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5C2 3.89543 2.89543 3 4 3H19C20.1046 3 21 3.89543 21 5V11C21 11.5523 20.5523 12 20 12C19.4477 12 19 11.5523 19 11V5H4V14H10.6161C11.1684 14 11.6161 14.4477 11.6161 15C11.6161 15.5523 11.1684 16 10.6161 16H4C2.89543 16 2 15.1046 2 14V5Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 9.5C14 10.875 12.875 12 11.5 12C10.125 12 9 10.875 9 9.5C9 8.125 10.125 7 11.5 7C12.875 7 14 8.125 14 9.5ZM12.3333 9.5C12.3333 9.04167 11.9583 8.66667 11.5 8.66667C11.0417 8.66667 10.6667 9.04167 10.6667 9.5C10.6667 9.95833 11.0417 10.3333 11.5 10.3333C11.9583 10.3333 12.3333 9.95833 12.3333 9.5Z",
    fill: color
  }));
};

export { Transfer };
